export default __webpack_public_path__ + "static/media/stickerAchievement.4f7d332f.png";